/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_phred_hint_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter a Phred quality score.`)
};

const es_phred_hint_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Introduce una puntuación de calidad Phred.`)
};

const de_phred_hint_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geben Sie einen Phred-Qualitätswert ein.`)
};

const nl_phred_hint_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vul een Phred-kwaliteitsscore in.`)
};

const fr_phred_hint_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrez un score de qualité Phred.`)
};

const it_phred_hint_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserisci un punteggio di qualità Phred.`)
};

const pt_br2_phred_hint_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informe um escore de qualidade Phred.`)
};

const pt_phred_hint_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Introduza uma pontuação de qualidade Phred.`)
};

const ja_phred_hint_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phred品質スコアを入力してください。`)
};

const zh_phred_hint_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`输入 Phred 质量分数。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const phred_hint_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.phred_hint_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("phred_hint_q", locale)
	if (locale === "en") return en_phred_hint_q(inputs)
	if (locale === "es") return es_phred_hint_q(inputs)
	if (locale === "de") return de_phred_hint_q(inputs)
	if (locale === "nl") return nl_phred_hint_q(inputs)
	if (locale === "fr") return fr_phred_hint_q(inputs)
	if (locale === "it") return it_phred_hint_q(inputs)
	if (locale === "pt-BR") return pt_br2_phred_hint_q(inputs)
	if (locale === "pt") return pt_phred_hint_q(inputs)
	if (locale === "ja") return ja_phred_hint_q(inputs)
	return zh_phred_hint_q(inputs)
};